import {ActionTypes} from "../../../../appbuilder/models/actions/actionTypes";
import {PAYMENTS_ENDPOINT} from "../constants";


export class PaymentsUrlBuilder {
    baseUrl: string;
    queryParams: Object;

    constructor(queryParams: Object) {
        this.baseUrl = window.location.toString()
            .substring(0, window.location.toString().indexOf("/VDP"))
            + PAYMENTS_ENDPOINT;

        this.queryParams = queryParams;
    }

    toString() {
        let urlStr = this.baseUrl;
        let index = 0;
        for (const prop in this.queryParams) {
            if (this.queryParams.hasOwnProperty(prop)) {
                if (index++ === 0) {
                    urlStr += "?";
                } else {
                    urlStr += "&";
                }

                urlStr += `${prop}=${this.queryParams[prop]}`;
            }
        }

        return urlStr;
    }
}
